import { makeObservable, observable, action } from "mobx";
import { onValue, push, ref, set, update, remove } from "firebase/database";
import { message } from "antd";
import {
  getUserId,
  setUserProps,
  trackEvent,
  trackPixelEvent,
} from "../../helpers";
import { database } from "../../configs";

export default class Establishments {
  mainStore;

  list = null;

  constructor(mainStore) {
    makeObservable(this, {
      list: observable,
      setList: action,
    });

    this.mainStore = mainStore;
  }

  async index() {
    const userID = await getUserId();
    const refValue = ref(database, `${userID}/Establishments`);

    await onValue(refValue, (items) => {
      const dataEstablishments = [];

      items.forEach((item) => {
        const data = item.val();
        dataEstablishments.push({
          ...data,
        });
      });
      this.setList(dataEstablishments);
    });
  }

  async create(value, formatMessage) {
    const name = (value || "").trim();
    if (!name) {
      message.error(formatMessage({ id: "establishment.create.error" }));
      return null;
    }

    try {
      const userID = await getUserId();
      const establishmentsRef = ref(database, `${userID}/Establishments`);
      const newEstablishmentRef = push(establishmentsRef);

      await set(newEstablishmentRef, {
        id: newEstablishmentRef.key,
        establishment_name: name,
        settings: {
          is_theme_dark: true,
        },
      });

      trackEvent("establishment_created", {
        establishment_id: newEstablishmentRef.key,
      });
      trackPixelEvent("Lead", {
        content_name: "establishment_created",
        content_category: "activation",
      });

      message.success(formatMessage({ id: "establishment.created" }));

      return newEstablishmentRef.key;
    } catch (error) {
      window.console.error("Error creating establishment:", error);
      message.error(formatMessage({ id: "establishment.create.error" }));
      return null;
    }
  }

  async update(id, fieldParams, formatMessage, isSkipMessage = false) {
    try {
      const userID = await getUserId();
      const postListRef = ref(database, `${userID}/Establishments/${id}`);

      await update(postListRef, fieldParams);

      if (!isSkipMessage) {
        message.success(formatMessage({ id: "establishment.updated" }));
      }
    } catch (error) {
      if (!isSkipMessage) {
        message.error(formatMessage({ id: "establishment.update.error" }));
      }

      throw error;
    }
  }

  async delete(id, formatMessage) {
    try {
      const userID = await getUserId();
      const deleteListRef = ref(database, `${userID}/Establishments/${id}`);

      await remove(deleteListRef);

      trackEvent("establishment_deleted", { establishment_id: id });

      message.success(formatMessage({ id: "establishment.deleted" }));
    } catch (error) {
      message.error(formatMessage({ id: "establishment.remove.error" }));
    }
  }

  setList(value) {
    this.list = value || null;
    if (Array.isArray(value)) {
      setUserProps({ establishments_count: value.length });
    }
  }

  cleanup() {
    this.setList(null);
  }
}
